<script setup>
    import { ref } from 'vue'
    import { thirdPartyLicenses } from '../data/thirdPartyLicenses.js'

    // 開いている項目のライブラリ名を保持
    const openedName = ref('')

    // ライセンス本文の表示/非表示を切り替える
    const toggleOpen = (name) => {
        openedName.value = openedName.value === name ? '' : name
    }
</script>

<template>
    <main>
        <div class="licensesArea">
            <div class="titleArea">
                <p class="title">オープンソースライセンス</p>
            </div>
            <p class="description">
                本サービスは、以下のオープンソースソフトウェアを使用しています。
            </p>
            <ul class="licenseList">
                <li v-for="lib in thirdPartyLicenses" :key="lib.name" class="licenseItem">
                    <button type="button" class="licenseHeader" @click="toggleOpen(lib.name)">
                        <span class="libName">{{ lib.name }}</span>
                        <span class="libLicense">{{ lib.license }}</span>
                        <span class="toggleIcon">{{ openedName === lib.name ? '−' : '+' }}</span>
                    </button>
                    <pre v-if="openedName === lib.name" class="licenseText">{{ lib.licenseText }}</pre>
                </li>
            </ul>
            <div class="returnLogin">
                <router-link :to="{name: 'login'}">ログイン画面へ戻る</router-link>
            </div>
        </div>
    </main>
</template>

<style scoped>
.licensesArea {
    padding: 0 20% 40px 20%;
    background-color: #e7e6e6;
}
.titleArea .title {
    text-align: center;
    font-size: 40px;
    padding: 20px 0 0;
}
.description {
    text-align: center;
    margin: 20px 0;
}
.licenseList {
    list-style: none;
    padding: 0;
    margin: 0;
}
.licenseItem {
    background-color: white;
    border: 1px solid #969292;
    border-radius: 5px;
    margin-bottom: 10px;
}
.licenseHeader {
    width: 100%;
    display: flex;
    align-items: center;
    gap: 10px;
    background: none;
    border: none;
    padding: 12px 16px;
    cursor: pointer;
    text-align: left;
    font-size: 16px;
}
.libName {
    font-weight: bold;
    flex: 1;
}
.libLicense {
    color: #555;
}
.toggleIcon {
    width: 20px;
    text-align: center;
}
.licenseText {
    white-space: pre-wrap;
    word-break: break-word;
    background-color: #f5f5f5;
    border-top: 1px solid #969292;
    padding: 16px;
    margin: 0;
    font-size: 13px;
}
.returnLogin {
    margin: 20px 0;
    text-align: center;
}
@media (max-width: 1150px) {
    .licensesArea {
        padding: 0 10% 40px 10%;
    }
    .titleArea .title {
        font-size: 32px;
    }
}
@media (max-width: 768px) {
    .licensesArea {
        padding: 0 5% 40px 5%;
    }
    .titleArea .title {
        font-size: 28px;
    }
}
@media (max-width: 540px) {
    .licensesArea {
        padding: 0 4% 40px 4%;
    }
    .titleArea .title {
        font-size: 24px;
    }
    .licenseHeader {
        font-size: 14px;
    }
}
</style>
